import { render, staticRenderFns } from "./ElementConfigurableScaleFactTableColumn.vue?vue&type=template&id=1b417d50"
import script from "./ElementConfigurableScaleFactTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementConfigurableScaleFactTableColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports